import { Box } from '@mui/material';
import { FunctionComponent, useRef } from 'react';
import { Route, Routes } from 'react-router-dom';
import { AppPages } from '../../common/routing/app-navigator';
import MaintenancePoller from '../../maintenance/containers/MaintenancePoller';
import OnboardingContainer from '../../onboarding/containers/OnboardingContainer';
import CreateOrganizationContainer from '../../organizations/containers/CreateOrganizationContainer';
import WhatsNewPoller from '../../whats-new/containers/WhatsNewPoller';
import ApplicationsPage from '../pages/applications/ApplicationsPage';
import ArtifactsPage from '../pages/artifacts/ArtifactsPage';
import AuditLogsPage from '../pages/audit-logs/AuditLogsPage';
import ConfigureIDPPage from '../pages/configure-idp/ConfigureIDPPage';
import ConnectorsPage from '../pages/connectors/ConnectorsPage';
import EmailVerificationPage from '../pages/email-verification/EmailVerificationPage';
import ExclusionsPage from '../pages/exclusions/ExclusionsPage';
import ExecutiveSummaryPage from '../pages/executive-summary/ExecutiveSummaryPage';
import HomePage from '../pages/home/HomePage';
import InviteOnlyPage from '../pages/invite-only/InviteOnlyPage';
import IrrelevantAppsPage from '../pages/irrelevant-apps/IrrelevantAppsPage';
import IssuesPage from '../pages/issues/IssuesPage';
import OrgLoginPage from '../pages/login/OrgLoginPage';
import MembersPage from '../pages/members/MembersPage';
import PageNotFound from '../pages/page-not-found/PageNotFound';
import PipelineIssuesPage from '../pages/pipeline-issues/PipelineIssuesPage';
import PipelineSummaryPage from '../pages/pipeline-summary/PipelineSummaryPage';
import PoliciesPage from '../pages/policies/PoliciesPage';
import ResolvedIssuesPage from '../pages/resolved-issues/ResolvedIssuesPage';
import SbomPage from '../pages/sbom/SbomPage';
import ScanHistoryPage from '../pages/scans-history/ScanHistoryPage';
import SettingsPage from '../pages/settings/SettingsPage';
import UnauthorizedPage from '../pages/unauthorized/UnauthorizedPage';
import ScrollRefContext from '../utils/context/ScrollRefContext';
import ChangeTitleOnRouteChange from './routing/ChangeTitleOnRouteChange';
import PrivateRoute from './routing/PrivateRoute';
import PublicRoute from './routing/PublicRoute';
import ScrollTopOnRouteChange from './routing/ScrollTopOnRouteChange';
import Auth0ErrorHandler from './user/Auth0ErrorHandler';

const LayoutSwitcher: FunctionComponent = () => {
  const pageRef = useRef<HTMLElement>();

  return (
    <Box flexGrow={1} overflow='auto' ref={pageRef} position='relative'>
      <ScrollRefContext.Provider value={pageRef}>
        <Auth0ErrorHandler>
          <Routes>
            <Route element={<PublicRoute />}>
              <Route path={AppPages.Home} element={<HomePage />} />
              <Route path={AppPages.OrgLogin} element={<OrgLoginPage />} />
              <Route path={AppPages.OrgSignup} element={<OrgLoginPage />} />
              <Route path={AppPages.InviteOnly} element={<InviteOnlyPage />} />
              <Route
                path={AppPages.Unauthorized}
                element={<UnauthorizedPage />}
              />
              <Route
                path={AppPages.EmailVerification}
                element={<EmailVerificationPage />}
              />
            </Route>
            <Route element={<PrivateRoute />}>
              <Route
                path={AppPages.Onboarding}
                element={<OnboardingContainer />}
              />
              <Route
                path={AppPages.Dashboard}
                element={<ExecutiveSummaryPage />}
              />
              <Route
                path={AppPages.Applications}
                element={<ApplicationsPage />}
              />
              <Route path={AppPages.Issues} element={<IssuesPage />} />
              <Route
                path={AppPages.ResolvedIssues}
                element={<ResolvedIssuesPage />}
              />
              <Route
                path={AppPages.PipelineIssues}
                element={<PipelineIssuesPage />}
              />
              <Route path={AppPages.Settings} element={<SettingsPage />} />
              <Route path={AppPages.Connectors} element={<ConnectorsPage />} />
              <Route path={AppPages.Policies} element={<PoliciesPage />} />
              <Route path={AppPages.Members} element={<MembersPage />} />
              <Route path={AppPages.AuditLogs} element={<AuditLogsPage />} />
              <Route
                path={AppPages.IDPConfigure}
                element={<ConfigureIDPPage />}
              />
              <Route
                path={AppPages.IrrelevantApps}
                element={<IrrelevantAppsPage />}
              />
              <Route path={AppPages.Exclusions} element={<ExclusionsPage />} />
              <Route path={AppPages.Sbom} element={<SbomPage />} />
              <Route path={AppPages.Artifacts} element={<ArtifactsPage />} />
              <Route
                path={AppPages.ScanHistory}
                element={<ScanHistoryPage />}
              />
              <Route
                path={AppPages.PipelineSummary}
                element={<PipelineSummaryPage />}
              />
            </Route>

            <Route path='*' element={<PageNotFound />} />
          </Routes>
        </Auth0ErrorHandler>

        <ChangeTitleOnRouteChange />
        <CreateOrganizationContainer />
        <ScrollTopOnRouteChange scrollTarget={pageRef} />
        <WhatsNewPoller />
        <MaintenancePoller />
      </ScrollRefContext.Provider>
    </Box>
  );
};

export default LayoutSwitcher;
